import { render, staticRenderFns } from "./reg_user.vue?vue&type=template&id=0f2767be&"
import script from "./reg_user.vue?vue&type=script&lang=js&"
export * from "./reg_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QSelect,QInput,QBtn,QCard,QCardSection,QMarkupTable,QPagination,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QSelect,QInput,QBtn,QCard,QCardSection,QMarkupTable,QPagination,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
